import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, Linkedin, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#070A1E] border-t border-white/10 pt-16 pb-8 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-14 w-14 rounded-xl bg-white p-1.5 flex items-center justify-center shadow-lg shadow-blue-500/20">
              <img src="/logo.png" alt="Campus Senior" className="h-full w-full object-contain" />
            </div>
            <div>
              <div className="font-display font-bold text-lg"><span className="text-white">CAMPUS</span> <span className="text-[#2563EB]">SENIOR</span></div>
              <div className="text-xs text-slate-400 tracking-widest">— Know Before You Join. —</div>
            </div>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
            Ask someone who actually lives there. Connect with verified Campus Ambassadors at top Indian colleges — completely free during launch.
          </p>
          <div className="mt-6 space-y-2 text-sm text-slate-300">
            <a href="https://wa.me/917980481612" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><MessageCircle size={16} className="text-emerald-400"/>+91 7980481612</a>
            <a href="mailto:campussenior.in@gmail.com" className="flex items-center gap-2 hover:text-white"><Mail size={16} className="text-[#2563EB]"/>campussenior.in@gmail.com</a>
            <a href="https://instagram.com/campussenior.in" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><Instagram size={16} className="text-pink-400"/>@campussenior.in</a>
            <a href="https://linkedin.com/company/campussenior" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><Linkedin size={16} className="text-blue-400"/>@campussenior</a>
          </div>
        </div>

        <FooterCol title="For Students" items={[
          { to: "/colleges", label: "Find College" },
          { to: "/colleges", label: "Browse Ambassadors" },
          { to: "/#how-it-works", label: "How It Works" },
          { to: "/#offers", label: "Offers" },
        ]}/>
        <FooterCol title="Ambassadors" items={[
          { to: "/auth?mode=register", label: "Apply Now" },
          { to: "/#ambassador", label: "What You Get" },
          { to: "/dashboard/ambassador", label: "Dashboard" },
          { to: "/leaderboard", label: "Leaderboard" },
        ]}/>
        <FooterCol title="Company" items={[
          { to: "/#problem", label: "About Us" },
          { to: "/contact", label: "Contact Us" },
        ]}/>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <div>© 2025 Campus Senior · campussenior.in · Built in India</div>
        <div className="flex gap-5">
          <a href="#" className="hover:text-white">Privacy Policy</a>
          <a href="#" className="hover:text-white">Terms</a>
          <a href="#" className="hover:text-white">Refund</a>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="text-white font-semibold mb-3 text-sm">{title}</div>
      <ul className="space-y-2 text-sm text-slate-400">
        {items.map((it, i) => (
          <li key={i}>
            {it.to.startsWith("/#") ? <a href={it.to} className="hover:text-white">{it.label}</a> : <Link to={it.to} className="hover:text-white">{it.label}</Link>}
          </li>
        ))}
      </ul>
    </div>
  );
}
